<template>
  <b-pagination-nav :link-gen="linkGen" @change="clickPage" :number-of-pages="totalPages"
                    use-router></b-pagination-nav>
</template>
<script>
export default {
  name: 't-pagination',
  props: {
    totalPages: Number,
    notLinkGen: Boolean,

  },
  methods: {
    clickPage(page) {
      this.$emit('getPage', page)
    },
    linkGen(pageNum) {

      if(!this.notLinkGen){

        let query = ''

        Object.entries(this.$route.query).forEach(([key, value]) => {

          if (key !== 'page' && key!== 'codSuccess' && key!== 'codError') {
            query += `&${key}=${value}`
          }

        });

        //console.log('Query ' + JSON.stringify(this.$route.query))
        return `?page=${pageNum}${query}`

      }


    },
  }
}
</script>
<style>
</style>
